import ErrorIcon from '@mui/icons-material/Error';
import { Button } from '@mui/material';
import { type AsideTab, setAsideTab } from '@newStore/documentUI/documentUIState';
import { selectAsideHeaderTabValidationState } from '@store/selectors/asideSelectors';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../hooks/useTypedSelector';

interface AsideHeaderButtonProps {
  value: AsideTab;
  label: string;
}

const getValidationIcon = (state: string | null) => {
  if (state === 'INVALID') {
    return <ErrorIcon color="error" titleAccess="Error" />;
  }
  if (state === 'VALID_WITH_WARNINGS') {
    return <ErrorIcon color="warning" titleAccess="Waarschuwing" />;
  }
  return null;
};

const AsideHeaderTabButton: React.FC<AsideHeaderButtonProps> = ({ value, label }) => {
  const dispatch = useDispatch();

  const validationState = useTypedSelector(
    (state) =>
      state.documentUI.currentEditingNode &&
      selectAsideHeaderTabValidationState(state, state.documentUI.currentEditingNode, value),
  );

  const active = useTypedSelector((state) => state.documentUI.asideTab === value);

  return (
    <Button
      onClick={() => dispatch(setAsideTab(value))}
      variant={active ? 'contained' : 'outlined'}
      endIcon={getValidationIcon(validationState)}
    >
      {label}
    </Button>
  );
};

export default AsideHeaderTabButton;
